import React from 'react';
import cn from 'classnames';
import styles from './SettingWrapper.module.scss';

const SettingWrapper = ({
  title,
  children,
  as = 'li',
  columnDirection = false,
}) => {
  const Component = as;

  return (
    <Component
      className={cn(styles.root, { [styles.column]: columnDirection })}
      as={as}
    >
      {title && <p className={styles.title}>{title}</p>}
      {children}
    </Component>
  );
};

export default SettingWrapper;
